import { render } from "./AllUsers.vue?vue&type=template&id=0ebb1654&scoped=true"
import script from "./AllUsers.vue?vue&type=script&lang=js"
export * from "./AllUsers.vue?vue&type=script&lang=js"

import "./AllUsers.vue?vue&type=style&index=0&id=0ebb1654&scoped=true&lang=css"

import exportComponent from "/var/www/greenified-mono-staging/ims.greenified.se/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ebb1654"]])

export default __exports__